module.exports = __webpack_public_path__ + "d6c93a2a0bf7c7c207405724afa5226a.jpg";